var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroupFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8.807,
    viewBox: "0 0 14 8.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people_2_",
    "data-name": "people (2)",
    transform: "translate(0 -0.004)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37049",
    "data-name": "Path 37049",
    d: "M3.7,166.864c.043-.065.088-.129.135-.192l.1-.127-.113-.066a2.569,2.569,0,0,0-1.293-.346A2.5,2.5,0,0,0,0,168.593v.756a.258.258,0,0,0,.261.254H3.088v-.715c0-.082,0-.169.012-.274l0-.05c.008-.094.02-.186.034-.272l0-.012c.016-.094.036-.189.06-.287s.051-.185.082-.277l-.111-.037.118.017a3.685,3.685,0,0,1,.225-.517l.019-.036c.041-.076.085-.151.132-.223Zm0,0",
    transform: "translate(0 -161.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37050",
    "data-name": "Path 37050",
    d: "M43.617,54.023a1.3,1.3,0,1,0-1.336-1.3A1.32,1.32,0,0,0,43.617,54.023Zm0,0",
    transform: "translate(-41.091 -49.966)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37051",
    "data-name": "Path 37051",
    d: "M133.313,146.688c0-.035,0-.071-.008-.106s-.006-.047-.008-.07-.007-.063-.012-.094-.008-.048-.012-.072-.011-.06-.017-.09-.01-.047-.015-.07-.014-.061-.022-.091-.012-.043-.017-.065-.018-.064-.028-.1l-.018-.057q-.017-.051-.036-.1l-.018-.047c-.014-.037-.029-.074-.045-.11l-.016-.036q-.027-.06-.056-.119l-.012-.025c-.021-.043-.044-.086-.067-.128l-.007-.014q-.039-.069-.08-.136l0,0a3.534,3.534,0,0,0-5.657-.406l-.014.017c-.029.035-.058.07-.086.106l-.019.025c-.025.033-.05.067-.074.1l-.024.035c-.021.03-.041.061-.061.092l-.03.047c-.016.026-.032.053-.047.08s-.024.041-.036.062l-.032.06c-.015.028-.03.056-.044.085l0,.006a3.34,3.34,0,0,0-.207.541l-.006.02c-.011.039-.021.079-.03.118l-.009.036c-.008.036-.016.072-.023.109,0,.017-.006.034-.009.05q-.009.05-.016.1,0,.033-.009.067c0,.029-.007.058-.01.087s0,.06-.007.09,0,.045,0,.068c0,.054,0,.108,0,.162v1.063a.293.293,0,0,0,.3.288h6.37a.293.293,0,0,0,.3-.288v-1.063q0-.084,0-.167C133.317,146.728,133.315,146.708,133.313,146.688Zm0,0",
    transform: "translate(-122.78 -139.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37052",
    "data-name": "Path 37052",
    d: "M188.509,3.311a1.679,1.679,0,0,0,1.7-1.654,1.7,1.7,0,0,0-3.4,0A1.679,1.679,0,0,0,188.509,3.311Zm0,0",
    transform: "translate(-181.532 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37053",
    "data-name": "Path 37053",
    d: "M354.466,159.918a2.567,2.567,0,0,0-1.391.407l-.11.07.083.1a3.729,3.729,0,0,1,.475.729l.006.012c.024.049.047.1.069.148l.008.019c.021.049.041.1.063.156l0,.011c.042.114.079.228.109.342l.007.028c.012.046.023.092.033.139l.012.06c.007.037.014.074.02.111s.007.045.011.068.01.072.014.108.005.045.007.068c0,.039.007.078.009.118l0,.059c0,.059,0,.118,0,.178v.54h2.826a.258.258,0,0,0,.261-.254v-.756A2.5,2.5,0,0,0,354.466,159.918Zm0,0",
    transform: "translate(-342.992 -155.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37054",
    "data-name": "Path 37054",
    d: "M360.156,49.968a1.3,1.3,0,1,0-1.336-1.3A1.32,1.32,0,0,0,360.156,49.968Zm0,0",
    transform: "translate(-348.682 -46.025)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroupFilled);
export default __webpack_public_path__ + "static/media/user-group-filled.49e4047d8d30afd1fb871226771ad547.svg";
export { ForwardRef as ReactComponent };